import React from "react";

import { ContextProps } from "./useNavBar.types";
import { NavBarContext } from "./useNavBar.context";

export const NavBarProvider: React.FC<
  React.PropsWithChildren<ContextProps>
> = ({ children, ...providerValues }) => (
  <NavBarContext.Provider value={providerValues}>
    {children}
  </NavBarContext.Provider>
);
